export interface IsAllowedToInviteFriendsParams {
  spotsAvailable: number;
  userIsOnCurrentTeam: boolean;
  enrollmentOpen: boolean;
}

export function isAllowedToInviteFriends({
  userIsOnCurrentTeam,
  spotsAvailable,
  enrollmentOpen,
}: IsAllowedToInviteFriendsParams) {
  return userIsOnCurrentTeam && spotsAvailable > 0 && enrollmentOpen;
}
